export const createSafeResizeObserver = callback => {
  let frameId = null

  const safeCallback = entries => {
    // Cancel any pending callbacks
    if (frameId) {
      cancelAnimationFrame(frameId)
    }

    // Schedule the callback for the next frame
    frameId = requestAnimationFrame(() => {
      try {
        callback(entries)
      } catch (error) {
        console.error('ResizeObserver callback error:', error)
      }
    })
  }

  return new ResizeObserver(safeCallback)
}
